import { NgModule } from '@angular/core';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LocationsRoutingModule } from './locations-routing.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LocationsComponent } from './locations.component';
import { HomeComponent } from './home/home.component';
import { LocationDetailsComponent } from './location-details/location-details.component';
import { SearchResultsComponent } from './search-results/search-results.component';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  declarations: [LocationsComponent, HomeComponent, LocationDetailsComponent, SearchResultsComponent],
  imports: [
    CommonModule,
    LocationsRoutingModule,
    SharedModule,
    NgbModule,
    FormsModule
  ]
})
export class LocationsModule { }
